import React, { useState } from 'react';
import TextField from '@material-ui/core/TextField';
import { makeStyles } from '@material-ui/core/styles';
import { createTheme } from '@material-ui/core/styles';
import { useNavigate } from "react-router-dom";
import "./login.scss";
import { errorToast, successToast } from '../toastmessage/toastmessage';
import { login, tenant } from './loginService';
import { LinearProgress } from '@material-ui/core';

const theme = createTheme({
  palette: {
    primary: { main: '#F5B62A' },
    secondary: { main: '#383938' },
  }
});

const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(4),
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    padding: '30px',
    backgroundColor: 'white',
    borderradius: '4px',
    boxShadow: '0px 1px 5px 0px rgba(0,0,0,0.2), 0px 2px 2px 0px rgba(0,0,0,0.14), 0px 3px 1px -2px rgba(0,0,0,0.12)',
  },

  avatar: {
    margin: theme.spacing(2),
  },
  form: {
    width: '100%', // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
  signup: {
    margin: theme.spacing(-2, 0, 2),
  },
}));

export default function SignIn() {
  const classes = useStyles();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(false)
  const [loginFields, setloginFields] = useState({
    userName: "",
    password: "",
    userGroup: "admin"
  });

  const handleInputFields = (event) => {
    event.preventDefault()
    const { name, value } = event?.target;
    setloginFields((prevState) => {
      return {
        ...prevState,
        [name]: value,
      };
    });

  }

  const fetchTeantDetails = async (uniqueId) => {
    try {
      const tenantRes = await tenant(uniqueId);
      if (tenantRes?.status === 200) {
        sessionStorage.setItem('tenantDetails', JSON.stringify(tenantRes?.data?.result));
      }
    } catch (err) {
      errorToast(err?.response?.data?.error || err?.response?.data?.message)
    }
  }

  const submitLogin = async (event) => {
    event.preventDefault(); 
    setLoading(true)
    try {
      const loginRes = await login(loginFields);
      if (loginRes?.status === 200) {
        sessionStorage.setItem('loginDetails', JSON.stringify(loginRes?.data?.result));
        await fetchTeantDetails(loginRes?.data?.result?.tenantID)
        setLoading(false)
        successToast(loginRes?.data?.message);
        navigate("/home")
      }
    } catch (err) {
      setLoading(false)
      errorToast(err?.response?.data?.error || err?.response?.data?.message)
    }

  }

  return (
    <>
      {loading && <LinearProgress /> }
      <div className="login-container">
        <form onSubmit={submitLogin} method='POST'>
          <h2>AROGYANXT</h2>
          <div className="form-group">
            <TextField
              className={classes.inputF}
              variant="outlined"
              margin="normal"
              required
              fullWidth
              id="userName"
              value={loginFields.userName}
              label="User Name"
              name="userName"
              autoComplete="userName"
              autoFocus
              onChange={handleInputFields}
            />
          </div>
          <div className="form-group">
            <TextField
              variant="outlined"
              margin="normal"
              required
              fullWidth
              name="password"
              label="Password"
              type="password"
              id="password"
              autoComplete="current-password"
              value={loginFields?.password}
              onChange={handleInputFields}
            />
          </div>
          <div className="form-group">
            <button type="submit"
              // onClick={(e) => submitLogin(e)}
              disabled={loginFields?.userName?.length > 0 && loginFields?.password?.length > 0 ? false : true}
            >Submit

            </button>
          </div>
        </form>
      </div>
    </>
  );
}